import { useState } from "react";
import { motion } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { FadeIn } from "../FadeIn";
import { TESTIMONIALS } from "../../lib/images";

export const TestimonialsSection = () => {
  const [idx, setIdx] = useState(0);
  const current = TESTIMONIALS[idx];

  return (
    <section
      data-testid="testimonials-section"
      className="section-pad bg-ink container-x"
    >
      <FadeIn>
        <div className="eyebrow mb-3">Témoignages</div>
      </FadeIn>
      <div className="max-w-4xl">
        <motion.blockquote
          key={idx}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="font-display text-3xl md:text-5xl leading-[1.15] text-bone"
        >
          « {current.quote} »
        </motion.blockquote>
        <div className="mt-10 flex items-center justify-between">
          <div>
            <div className="flex gap-1 mb-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={12} className="fill-stone text-stone" />
              ))}
            </div>
            <div className="text-sm text-bone">{current.name}</div>
            <div className="text-xs text-bone/50">{current.org}</div>
          </div>
          <div className="flex items-center gap-2">
            <button
              data-testid="test-prev"
              onClick={() => setIdx((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
              className="w-12 h-12 border border-stone/40 flex items-center justify-center hover:bg-stone hover:text-ink transition-colors"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              data-testid="test-next"
              onClick={() => setIdx((i) => (i + 1) % TESTIMONIALS.length)}
              className="w-12 h-12 border border-stone/40 flex items-center justify-center hover:bg-stone hover:text-ink transition-colors"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
